export function displayPrice(price: number) {
  return price.toFixed(2).replace(".", ",");
}
